<template>
    <div>
        <e-dialog
                dialog-title="调价日志"
                :center-dialog-visible="adjustPriceLogrVisible"
                popup-width="800px"
                :closeBtn="true"
                :showCloseBtn="showCloseBtn"
                :showBtn="showBtn"
                @resetPopupData="handleClose">
            <div>
                <tableList
                        class="margin-t20"
                        rowKey="companyId"
                        :loading="false"
                        :table-data="tableData"
                        :table-label="tableLabel"
                        maxHeight="400">
                    <template v-slot:showIndex="slot">
                        {{ (queryData.pageNum - 1) * queryData.pageSize + slot.scope.$index + 1}}
                    </template>
                    <template v-slot:operate="slot">
                        <eui-btn type="text" color="#C0C4CC,#C0C4CC,#C0C4CC"
                                 v-if="hasAddData.some(item=>item.companyId === slot.scope.row.companyId)">已添加
                        </eui-btn>
                        <eui-btn type="text" @click="handleAddPurchaser(slot.scope.row)" v-else>添加</eui-btn>
                    </template>
                </tableList>
            </div>
        </e-dialog>
    </div>
</template>

<script>
  import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
  import tableList from '@/modules/projectA/components/common/e-table-list';
  import api from '../../../../../api/product';
  export default {
    name: "adjustPriceLogDialog",
    components: {
      eDialog,
      tableList
    },
    props: {
      adjustPriceLogrVisible: Boolean,
      priceId:String
    },
    data() {
      return {
        showCloseBtn:true,
        showBtn:false,
        tableData: [],
        tableLabel: [
          {label: '调价时间',  param:'createTime', align: 'center'},
          {label: '操作人',  param:'createName', align: 'center'},
          {label: '调前集采价(元)',  param:'priceBeforeChange', align: 'center'},
          {label: '调后集采价(元)',  param:'priceAfterChange', align: 'center'},
          {label: '审核时间',  param:'auditTime', align: 'center'},
          {label: '审核结果',  param:'auditStatus', align: 'center', render: (row) => {
        if(Number(row.auditStatus) === 2){
          return '审核通过'
        }
        if(Number(row.auditStatus) === 3){
          return '审核拒绝'
        }
      },},
          {label: '原因',  param:'refuseReasons', align: 'center'},
        ]
      }
    },
    methods: {
      handleClose() {
        this.$emit('handleClose', 'adjustPriceLogrVisible');
      },
      async queryPriceChangeLog(){
        let res = await api.queryPriceChangeLog({priceId:this.priceId});
        if(res.success){
          this.tableData = res.data;
        }
      },
    },
    mounted() {
      this.queryPriceChangeLog();
    }
  }
</script>

<style scoped lang="scss">

</style>